export default __webpack_public_path__ + "static/free-course-b0d9daf12e0f9a293c1d050b38c618d0.png";